import React, { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ScanLine, AlertTriangle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ScanCard() {
  const { t } = useI18n();
  const [token, setToken] = useState("");
  const [res, setRes] = useState(null);

  const parseToken = (v) => v.includes("INZEAIR:CARD:") ? v.split("INZEAIR:CARD:")[1].trim() : v.trim();
  const verify = async () => {
    const tk = parseToken(token);
    if (!tk) return;
    try { const { data } = await api.get(`/people/cards/verify/${encodeURIComponent(tk)}`); setRes(data); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); setRes(null); }
  };

  return (
    <div data-testid="scan-card" className="max-w-lg">
      <div className="flex items-center gap-2 mb-6">
        <ScanLine className="h-6 w-6 text-primary" />
        <h1 className="text-2xl font-display font-bold text-slate-900">{t("scanCard")}</h1>
      </div>
      <Card className="border-slate-200 p-5">
        <p className="text-sm text-slate-500 mb-3">{t("scanManualHint")}</p>
        <div className="flex gap-2">
          <Input data-testid="scan-token-input" placeholder="INZEAIR:CARD:… / token" value={token} onChange={(e) => setToken(e.target.value)} onKeyDown={(e) => e.key === "Enter" && verify()} />
          <Button data-testid="scan-verify-btn" onClick={verify}>{t("verify") || "Vérifier"}</Button>
        </div>
      </Card>

      {res && (
        <Card className={`mt-4 p-5 border ${res.valid ? "border-emerald-200 bg-emerald-50" : "border-red-200 bg-red-50"}`} data-testid="scan-result">
          <div className="flex items-center gap-2 mb-2">
            {res.valid ? <CheckCircle2 className="h-5 w-5 text-emerald-600" /> : <AlertTriangle className="h-5 w-5 text-red-600" />}
            <span className={`font-semibold ${res.valid ? "text-emerald-700" : "text-red-700"}`} data-testid="scan-valid">
              {res.valid ? t("cardValid") : t("cardInvalid")}
            </span>
            <Badge className="ml-auto border-0 bg-white">{res.status || "—"}</Badge>
          </div>
          <div className="text-sm text-slate-700">{res.student_name || "—"}</div>
          <div className="text-xs text-slate-500">{res.card_uid || ""}</div>
        </Card>
      )}
    </div>
  );
}
